import { useQuery } from '@tanstack/react-query';
import getGlobalScopeSettings from '../services/GlobalScopeService';
/**
 * Custom hook to fetch global scope settings (territories and companies)
 * @param options - Optional query configuration options
 * @returns UseQueryResult with global scope settings data
 */
export default function useGlobalScope(options) {
    return useQuery({
        queryKey: ['global-scope-settings'],
        queryFn: getGlobalScopeSettings,
        staleTime: 300000, // 5 minutes
        enabled: (options === null || options === void 0 ? void 0 : options.enabled) !== false // Enabled by default unless explicitly disabled
    });
}
